export default __webpack_public_path__ + "static/Continuous-Integration-cb9c5006ab3e5ecbd6bf37b351f09f20.webp";